import React from "react";
import Heading from "../../components/heading/heading";
import ProfileInterests from "../../components/profile-interests/profile-interests";
import ProfileMenu from "../../components/profile-menu/profile-menu";


export function ProfileInterestsPage({ withProfileMenu = false }) {
    const fromShow = withProfileMenu ? 'profile' : 'rega';
    return (
        <>
            {withProfileMenu && <ProfileMenu />}
            {!withProfileMenu && (<Heading tpl="new">Мои <span className="my-text-primary">интересы</span></Heading>)}
            <ProfileInterests fromShow={fromShow} />
        </>
    );
}

